export default __webpack_public_path__ + "static/media/wait.a38ee26e.svg";